
<script setup>
import axios from "axios";
import { ref } from "vue";
const isDownloadCsv = ref(false);
const downloadItem = async () => {
  await axios
    .get(
      "https://zjfdkyiamhvqhixutolr.supabase.co/storage/v1/object/public/Documentos/Curriculum%20vitae_Augusto%20Silva_2023.pdf?t=2023-05-14T15%3A18%3A16.202Z",
      { responseType: "blob" }
    )
    .then((response) => {
      isDownloadCsv.value = true;
      const blob = new Blob([response.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Curriculum-augusto-silva";
      link.click();
      URL.revokeObjectURL(link.href);
    })
    .catch(console.error)
    .finally(() => {
      isDownloadCsv.value = false;
    });
};
</script>

<template>
  <v-col cols="12" class="mt-16" id="about">
    <div>
      <v-row>
        <v-col cols="12" sm="6">
          <div class="egg">
            <v-img src="murilio.webp" max-height="300" class=""></v-img>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <h5 class="mt-16">Sobre me</h5>
          <div>
            <v-row>
              <v-col cols="1" align-self="center" class="my-5">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://vuejs.org/images/logo.png"
                ></v-img>
              </v-col>
              <v-col cols="1" align-self="center">
                <v-img
                    class="bg-white"
                    width="50"
                    :aspect-ratio="1"
                    src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
                ></v-img>
              </v-col>
              <v-col cols="1" align-self="center">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://cdn.quasar.dev/logo-v2/512/logo.png"
                ></v-img>
              </v-col>
              <v-col cols="1" align-self="center">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png"
                ></v-img>
              </v-col>
              <v-col cols="1" align-self="center">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://cdn.icon-icons.com/icons2/3053/PNG/512/mysql_workbench_macos_bigsur_icon_189924.png"
                ></v-img>
              </v-col>

              <v-col cols="1" align-self="center">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/1200px-Postgresql_elephant.svg.png"
                ></v-img>
              </v-col>
              <v-col cols="1" align-self="center">
                <v-img
                  class="bg-white"
                  width="50"
                  :aspect-ratio="1"
                  src="https://leadgenapp.io/wp-content/uploads/2022/03/9f34aa95d848d5418eff70244e2d8c6e_3.png"
                ></v-img>
              </v-col>
            </v-row>
          </div>
          <h4 class="mt-n4">Eu sou um Desenvolvedor Front-end - VueJS</h4>
<div class="text-grey-3 text-justify">
          <p>Olá, sou um desenvolvedor formado em Análise e Desenvolvimento de Sistemas, e desde 2018 venho trabalhando com programação. Eu sou apaixonado por tecnologia e adoro enfrentar novos desafios. Durante a minha carreira, eu tive a oportunidade de trabalhar em projetos de desenvolvimento web usando as tecnologias mais recentes, incluindo VueJS, HTML, CSS, JavaScript e NodeJS.</p>
  <br>
          <p>Com minha experiência em VueJS, tenho habilidades excepcionais em desenvolvimento front-end, criando interfaces de usuário dinâmicas e responsivas. Meu conhecimento em HTML, CSS e JavaScript me permite criar sites e aplicações web incríveis que impressionam os usuários. Além disso, meu conhecimento em NodeJS me permite desenvolver soluções robustas e escaláveis no backend.</p>
  <br>
          <p>Estou sempre aprendendo e me atualizando com as tecnologias mais recentes para fornecer as melhores soluções para meus clientes. Se você precisa de um desenvolvedor altamente qualificado para trabalhar em seu próximo projeto, não hesite em entrar em contato comigo.</p>
</div>
          <v-btn
            :loading="isDownloadCsv"
            tile
            dark
            color="red"
            @click="downloadItem()"
            class="mt-4"
          >
            Download CSV
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-col>
</template>


<style scoped>

</style>
